export default "__VITE_ASSET__d8b98b9d__"